import { useEffect, useState } from 'react';
import { getAbType } from '@/api/abTest.ts';
import { sendEvent } from '@/api/nativeBridge.ts';
import type { AbType } from '@/features/discover/types/types.ts';

const useAbType = (): AbType | undefined => {
  const [abType, setAbType] = useState<AbType | undefined>(undefined);

  useEffect(() => {
    (async () => {
      const type = await getAbType();
      setAbType(type);
      sendEvent('GET_ABTEST_TYPE', { type });
    })();
  }, []);

  return abType;
};

export default useAbType;
